import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../queryKeys';
import { homeApi } from '../api/home';

export function useHome(batchId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.lms.home(batchId ?? ''),
    queryFn: async () => {
      const { data } = await homeApi.getHome(batchId);
      return data;
    },
    enabled: !!batchId || batchId === 'all',
    staleTime: 60_000,
  });
}

// useStreak is a light read used by the layout topbar; reuses the home cache.
export function useStreak(batchId: string | undefined) {
  const { data } = useHome(batchId);
  return data?.streak?.current ?? 0;
}
